import { FormControl, Grid, InputLabel, Switch } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

import { isActivateToggleEnabled } from '../../DataProvider/DataProvider.service';
import { SourceDialogMode } from '../../SourceCreate.types';
import type { ActiveToggleProps } from './ActiveToggle.types';

/**
 * ActiveToggle renders an active/inactive switch for sources.
 * Only shown in Edit mode to enable/disable sources.
 * Some sources cannot be deactivated based on business rules (checked by isActivateToggleEnabled).
 */
const ActiveToggle = ({
  mode,
  sourceStatus,
  onSourceStatusChange,
  selectedSourceDetails,
  xs = 12,
  sm = 12,
  md = 12
}: ActiveToggleProps) => {
  const { control } = useFormContext();

  if (mode !== SourceDialogMode.Edit) return null;

  return (
    <Grid size={{ xs, sm, md }}>
      <InputLabel>Active</InputLabel>
      <FormControl fullWidth>
        <Controller
          name="active"
          control={control}
          defaultValue={sourceStatus}
          render={({ field }) => (
            <Switch
              {...field}
              checked={field.value}
              onChange={(e) => {
                onSourceStatusChange(e.target.checked);
                field.onChange(e.target.checked);
              }}
              disabled={
                !selectedSourceDetails ||
                !isActivateToggleEnabled(selectedSourceDetails)
              }
              color={field.value ? 'success' : 'error'}
            />
          )}
        />
      </FormControl>
    </Grid>
  );
};

export default ActiveToggle;
